import { Chock } from "@/pages/catalogs/models/Chock";
import { ErrorModal, getMomentTz } from "@dexteel/mesf-core";
import { Grid2 } from "@mui/material";
import { DateTimeField } from "@mui/x-date-pickers";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Part } from "../../models/Part";
import { getChocks } from "../../repositories/parts/ChockRepository";

const moment = getMomentTz();

type useChocksProps = {
	partId: number;
	onError: (error: Error) => void;
	onSuccess?: (data: Chock[]) => void;
};

export const useChocks = ({ partId, onError, onSuccess }: useChocksProps) => {
	return useQuery<Chock[], Error>({
		queryKey: ["chocks", partId],
		meta: { realtime: ["M2.GetChocks"] },
		queryFn: ({ signal }) => getChocks({ partId }, signal),
		onError: onError,
		onSuccess: onSuccess,
	});
};

type Props = {
	part: Part | null;
};

export const SpecificChockData = ({ part }: Props) => {
	const [error, setError] = useState("");
	const [chock, setChock] = useState<Chock>();

	const { data: chocks } = useChocks({
		partId: part?.PartId!,
		onError: (error) => setError(error.message),
		onSuccess: (data: Chock[]) => {
			setChock(data[0]);
		},
	});

	return (
		<>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<DateTimeField
						value={
							chock?.RebuildTimestamp
								? moment.utc(chock.RebuildTimestamp)
								: null
						}
						label="Rebuild Date"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<DateTimeField
						value={
							chock?.BearingChangeTimestamp
								? moment.utc(chock.BearingChangeTimestamp)
								: null
						}
						label="Bearing Change Date"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
